import { DextUrlInputWUT } from '@wix/form-fields/wut';

export default DextUrlInputWUT;
